import produce from 'immer'

export default (state = { cameras: [], isLoading: true }, action) => produce(state, draft => {
  let cameraIndex
  switch (action.type) {
  case 'LOAD_CAMERAS_FAIL':
    draft.isLoading = true
    return
  case 'LOAD_CAMERAS_SUCCESS':
    draft.cameras.splice(0, draft.cameras.length, ...action.cameras)
    draft.isLoading = false
    return
  case 'LOAD_CAMERA_SUCCESS':
  case 'CREATE_CAMERA_SUCCESS':
  case 'UPDATE_CAMERA_SUCCESS':
    cameraIndex = draft.cameras.findIndex(camera => camera._id === action.camera._id)
    if (cameraIndex > -1) {
      draft.cameras.splice(cameraIndex, 1, action.camera)
    } else {
      draft.cameras.push(action.camera)
      if (draft.cameras.length > 1) {
        draft.cameras.sort((one, another) => {
          if (one.locales.EN.name > another.locales.EN.name) {
            return 1
          } else if (one.locales.EN.name < another.locales.EN.name) {
            return -1
          } else {
            return 0
          }
        })
      }
    }
    return
  case 'DELETE_CAMERA_SUCCESS':
    draft.cameras = draft.cameras.filter(camera => camera._id !== Number(action.cameraId))
    return
  }
})
